const isPoor = (sample) => (sample.lossFraction !== null && sample.lossFraction > 0.05) ||
    (sample.jitterMs !== null && sample.jitterMs > 200) ||
    (sample.rttMs !== null && sample.rttMs > 500) ||
    sample.freezeDurationDeltaMs > 500 ||
    (sample.hasExpectedRemoteVideo && sample.framesDecodedPerSecond === 0);
const isHealthy = (sample) => (sample.lossFraction === null || sample.lossFraction <= 0.015) &&
    (sample.jitterMs === null || sample.jitterMs <= 80) &&
    (sample.rttMs === null || sample.rttMs <= 300) &&
    (!sample.hasExpectedRemoteVideo || sample.framesDecodedPerSecond === null || sample.framesDecodedPerSecond > 0);
/** Stateful hysteresis for 1:1 video quality. Browser stats are noisy; callers feed one sample/sec. */
export class VideoQualityMonitor {
    constructor() {
        this.samples = [];
        this.state = 'GOOD';
        this.consecutivePoor = 0;
        this.consecutiveHealthy = 0;
    }
    add(sample) {
        this.samples = [...this.samples.slice(-14), sample];
        this.consecutivePoor = isPoor(sample) ? this.consecutivePoor + 1 : 0;
        this.consecutiveHealthy = isHealthy(sample) && !isPoor(sample) ? this.consecutiveHealthy + 1 : 0;
        const next = this.consecutivePoor >= 5 ? 'POOR' : this.consecutiveHealthy >= 15 ? 'GOOD' : 'DEGRADED';
        const changed = next !== this.state;
        this.state = next;
        return { state: next, changed, samples: this.samples };
    }
}
